export default __webpack_public_path__ + "../images/apple-touch-icon-114x114.png";